import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IModule } from 'src/app/interfaces/IModule';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';

@Component({
  selector: 'app-self-report-section',
  templateUrl: './self-report-section.component.html',
  styleUrls: ['./self-report-section.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelfReportSectionComponent {
  @Input() submenu?: IModule[];

  constructor(private readonly eocService: EpisodeOfCareService) {}

  ngOnInit() {}
}
